import React from 'react';
import { FieldProps } from 'formik';
import { RadioGroup } from '@headlessui/react';
import clsx from 'clsx';

const UnitRadio: React.ComponentType<FieldProps> = props => {
  return (
    <RadioGroup
      value={props.field.value}
      className="w-36"
      onChange={status => {
        props.form.setFieldValue(props.field.name, status);
      }}
    >
      <RadioGroup.Label className="block text-sm font-medium text-gray-700 mb-1">
        Unit of time
      </RadioGroup.Label>
      <div className="flex">
        <RadioGroup.Option
          value="HOURS"
          className={({ checked }) =>
            clsx(
              checked
                ? 'bg-secondary-700 border-transparent text-white hover:bg-secondary-600'
                : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50',
              'rounded-l-md border py-2 px-3 flex items-center justify-center text-sm font-medium sm:flex-1 cursor-pointer focus:outline-none'
            )
          }
        >
          <RadioGroup.Label as="p">Hours</RadioGroup.Label>
        </RadioGroup.Option>
        <RadioGroup.Option
          value="DAYS"
          className={({ checked }) =>
            clsx(
              checked
                ? 'bg-secondary-700 border-transparent text-white hover:bg-secondary-600'
                : 'bg-white border-gray-200 text-gray-900 hover:bg-gray-50',
              'rounded-r-md border py-2 px-3 flex items-center justify-center text-sm font-medium sm:flex-1 cursor-pointer focus:outline-none'
            )
          }
        >
          <RadioGroup.Label as="p">Days</RadioGroup.Label>
        </RadioGroup.Option>
      </div>
    </RadioGroup>
  );
};

export default UnitRadio;
